import plyr from 'plyr';
import 'plyr/dist/plyr.css';

let active;
let songs;
let radio;

function loadPlyr() {
    let plyrr = plyr.setup(document.querySelector('.plyr'));
    radio = plyrr[0];
    let player = document.querySelector('.playlist');
    songs = player.querySelectorAll('.playlist--list li');
    let i;
    active = null;

    for (i = 0; i < songs.length; i++) {
        songs[i].onclick = changeChannel;
    }

    if (songs.length)
        setSource(getId(songs[0]), buildSource(songs[0]));

    document.querySelector('.plyr').addEventListener('ended', nextSong);
    return radio;
}

function changeChannel(e) {
    setSource(getId(e.target), buildSource(e.target), true);
    setArt(e.target);
}

function getId(el) {
    return Number(el.getAttribute('data-id'));
}

function buildSource(el) {
    let obj = [{
        src: el.getAttribute('data-audio'),
        artist: el.getAttribute('data-artist'),
        type: 'audio/mp3'
    }];
    return obj;
}

function setSource(selected, sourceAudio, play) {
    if (active !== selected) {
        active = selected;
        radio.source({
            type: 'audio',
            title: 'test',
            poster: sourceAudio[0].image,
            sources: sourceAudio
        });

        for (let i = 0; i < songs.length; i++) {
            if (Number(songs[i].getAttribute('data-id')) === selected) {
                songs[i].classList.add('active');
            } else {
                songs[i].classList.remove('active');
            }
        }

        if (play) {
            radio.play();
        }
    } else {
        radio.togglePlay();
    }
}

function setArt(e) {
    console.log(e);
}

function nextSong(e) {
    let next = active + 1;

    if (next < songs.length) {
        setSource(getId(songs[next]), buildSource(songs[next]), true);
    }
}

export default loadPlyr;
/*
module.exports = {
    loadPlyr:loadPlyr,
    setArt: setArt,
    nextSong: nextSong,
    changeChannel: changeChannel,
    getId: getId,
    buildSource: buildSource,
    setSource: setSource,
    setArt: setArt,
    nextSong: nextSong
  };*/
